import { configureStore } from "@reduxjs/toolkit";
import alertMessage from "../slice/alertMessage";
import deliveryPartnerView from "../slice/deliveryPartnerView";
import { rtkQueryErrorLogger } from "../slice/errorLogger";

const store = configureStore({
  reducer: {
    alertMessage: alertMessage,
    deliveryPartnerView: deliveryPartnerView,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkQueryErrorLogger),
});

export default store;
